import { render, staticRenderFns } from "./ChildListDetails.vue?vue&type=template&id=22e59516&"
import script from "./ChildListDetails.vue?vue&type=script&lang=js&"
export * from "./ChildListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports